import React, { useMemo } from 'react';
import { Pagination, useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import { SCREEN_TABLET } from '../../config/constants';
import './style.scss';

export interface PagerProps {
  currentPage?: number;
  totalPages?: number;
  pageRangeDisplayed?: number;
  marginPagesDisplayed?: number;
  setCurrentPage?: (page: number) => void;
  previousLabel?: string | JSX.Element;
  nextLabel?: string | JSX.Element;
  containerClassName?: string;
  disabledClassName?: string;
  activeClassName?: string;
  showWhenOnePage?: boolean;
  controlled?: boolean;
  scrollToTop?: boolean;
  scrollToTopOffset?: number;
  scrollToTopBehavior?: string;
}

const Pager: React.FC<PagerProps> = ({
  totalPages,
  currentPage,
  setCurrentPage,
  ...props
}) => {
  const { width } = useWindowDimensions();

  const marginPagesDisplayed = useMemo(() => {
    if (width > SCREEN_TABLET && totalPages) {
      return totalPages > 6 ? 1 : 0;
    }

    return 0;
  }, [totalPages, width]);

  return (
    <div className="Pagination__wrapper">
      <Pagination
        totalPages={totalPages}
        currentPage={currentPage ? currentPage + 1 : 1}
        setCurrentPage={(index: number) => {
          if (setCurrentPage) {
            setCurrentPage(index - 1);
          }
        }}
        pageRangeDisplayed={totalPages && totalPages > 6 ? 2 : 5}
        marginPagesDisplayed={marginPagesDisplayed}
        previousLabel={<i className="icon icon-before icon-caret-left" />}
        nextLabel={<i className="icon icon-before icon-caret-right" />}
        {...props}
      />
    </div>
  );
};

export default Pager;
